<script>
const splitIntoColumns = (items, getDimensions, columns, gap) => {
  const itemsInColumns = new Array(columns).fill().map(() => [])
  const columnWeights = new Array(columns).fill(0)
  items.forEach(item => {
    const nimW = Math.min(...columnWeights)
    const index = columnWeights.findIndex(w => w === nimW)
    const { width = 0, height = 0 } = getDimensions(item)
    itemsInColumns[index].push(item)
    columnWeights[index] += (height + gap) / width || 0
  })
  return itemsInColumns
}

export default {
  name: 'container-columns',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    cols: {
      type: Number,
      default: 1,
      validator: num => num >= 1
    },
    gap: {
      type: Number,
      default: 0
    },
    // must be return a value { width, height }
    getDimensions: {
      type: Function,
      default: item => item
    }
  },
  computed: {
    columnsStyle () {
      return `grid-template-columns: repeat(${this.cols}, 1fr); gap: ${this.gap}px;`
    },
    columnStyle () {
      return `gap: ${this.gap}px;`
    }
  },
  render (h) {
    const cols = splitIntoColumns(this.items, this.getDimensions, this.cols, this.gap)
    const columns = cols.map(col =>
      h(
        'div',
        { class: 'container-columns__column', style: this.columnStyle },
        col.map(item => this.$scopedSlots.default({ item }))
      )
    )
    const container = h('div', { class: 'container-columns', style: this.columnsStyle }, columns)
    return container
  }
}
</script>

<style scoped lang="scss">
.container-columns {
  align-items: start;
  display: grid;
  &__column {
    align-items: center;
    display: grid;
    grid-auto-flow: row;
    & > * {
      max-width: 100%;
    }
  }
}
</style>
